import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SideSingleComponent from './SideSingleComponent'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  scrollContainer: {
    overflow: 'scroll',
    width: 'calc(100%)',
    height: 'calc(100%)',
    padding: 4
  }
})
const propTypes = {
  classes: PropTypes.object.isRequired,
  transactions: PropTypes.array.isRequired,
  playTransaction: PropTypes.func.isRequired,
  pauseTransaction: PropTypes.func.isRequired,
  removeSideTable: PropTypes.func.isRequired,
  prepareForPayment: PropTypes.func.isRequired
}

class SideListComponent extends Component {
  render() {
    const { classes, transactions } = this.props
    return (
      <Grid item className={classes.scrollContainer}>
        <Grid
          container
          direction="row"
          alignItems="stretch"
          justify="flex-start"
          spacing={8}>
          {transactions.map((transac, index) => {
            if (transac.transfertTo || transac.canceled) return null
            return (
              <Grid
                item
                key={transac.key}
                xs={12}
                sm={12}
                md={12}
                lg={transactions.length >= 4 ? 6 : 12}
                xl={transactions.length >= 4 ? 6 : 12}>
                <SideSingleComponent
                  transaction={transac}
                  playTransaction={this.props.playTransaction}
                  pauseTransaction={this.props.pauseTransaction}
                  prepareForPayment={this.props.prepareForPayment}
                  removeSideTable={this.props.removeSideTable}
                />
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    )
  }
}

SideListComponent.propTypes = propTypes
export default withStyles(styles)(SideListComponent)



// WEBPACK FOOTER //
// ./src/routes/Home/components/SideListComponent.js